import { SkeletonLoading } from '@saleshandy/design-system';
import React from 'react';
import SequenceSingleSkeletonView from '../sequence-single-content/components/sequence-single-step-list/helpers/sequence-single-steps-skeleton-view';

const SingleSequenceFallback: React.FC = () => (
  <>
    <div className="single-sequence-fallback-header">
      <div className="single-sequence-fallback-header--left">
        <SkeletonLoading width={58} height={20} />
        <SkeletonLoading width={100} height={20} />
        <SkeletonLoading width={44} height={20} />
        <SkeletonLoading width={72} height={20} />
      </div>
      <div className="single-sequence-fallback-header--right">
        <SkeletonLoading width={145} height={28} />
        <SkeletonLoading width={100} height={32} />
      </div>
    </div>
    <SequenceSingleSkeletonView />
  </>
);

export default SingleSequenceFallback;
